"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _flyout = require("../../flyout");

var _layout = require("../../layout");

var _popover = require("../../popover");

var _responsive = require("../../responsive");

var _utils = require("../../utils");

var _dateTimeSegments = require("../date-time-segments");

var _DateTimeInputComponent = _interopRequireDefault(require("./DateTimeInputComponent"));

var _DateTimeInputPopupContent = _interopRequireDefault(require("./DateTimeInputPopupContent"));

var _constants = require("./constants");

var _propTypes = require("./propTypes");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["ariaLabels", "calendarButtonAltText", "clearButtonAltText", "collapsedCloseButtonAltText", "collapsedTitleText", "defaultTime", "disabled", "error", "id", "inputProps", "labelId", "locale", "onChange", "popoverProps", "showSeconds", "showMilliseconds", "value", "warning"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DateTimeInputWithoutDocs = function DateTimeInputWithoutDocs(_ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? _constants.defaultDateTimeInputProps.ariaLabels : _ref$ariaLabels,
      _ref$calendarButtonAl = _ref.calendarButtonAltText,
      calendarButtonAltText = _ref$calendarButtonAl === void 0 ? _constants.defaultDateTimeInputProps.calendarButtonAltText : _ref$calendarButtonAl,
      clearButtonAltText = _ref.clearButtonAltText,
      _ref$collapsedCloseBu = _ref.collapsedCloseButtonAltText,
      collapsedCloseButtonAltText = _ref$collapsedCloseBu === void 0 ? _constants.defaultDateTimeInputProps.collapsedCloseButtonAltText : _ref$collapsedCloseBu,
      _ref$collapsedTitleTe = _ref.collapsedTitleText,
      collapsedTitleText = _ref$collapsedTitleTe === void 0 ? _constants.defaultDateTimeInputProps.collapsedTitleText : _ref$collapsedTitleTe,
      defaultTime = _ref.defaultTime,
      disabled = _ref.disabled,
      error = _ref.error,
      id = _ref.id,
      _ref$inputProps = _ref.inputProps,
      inputProps = _ref$inputProps === void 0 ? {} : _ref$inputProps,
      labelIdProp = _ref.labelId,
      locale = _ref.locale,
      onChange = _ref.onChange,
      _ref$popoverProps = _ref.popoverProps,
      popoverProps = _ref$popoverProps === void 0 ? _constants.defaultDateTimeInputProps.popoverProps : _ref$popoverProps,
      showSeconds = _ref.showSeconds,
      showMilliseconds = _ref.showMilliseconds,
      value = _ref.value,
      warning = _ref.warning,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var stateValue = (0, _react.useRef)();
  var containerRef = (0, _react.useRef)(null);
  var calendarButtonRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      segmentValues = _useState4[0],
      setSegmentValues = _useState4[1];

  var hasSegmentValues = (0, _utils2.hasAnySegmentValue)(segmentValues);
  var dataTestProps = (0, _utils.pick)(forwardedProps, _utils.dataTestKeys);
  var datePickerProps = (0, _utils.omit)(forwardedProps, _utils.dataTestKeys);
  (0, _utils.showDeprecationWarning)({
    deprecatedName: 'DateTimeInput',
    replacementName: 'PopupDatePicker with date-time props',
    docsLink: 'https://stencil.a2z.com/components/date-pickers/popup-date-picker/implementation#with-time'
  });
  (0, _react.useEffect)(function () {
    setSegmentValues(function (values) {
      var _objectSpread2;

      return _objectSpread(_objectSpread({}, values), {}, (_objectSpread2 = {}, (0, _defineProperty2.default)(_objectSpread2, _dateTimeSegments.DateTimeSegment.Seconds, showSeconds ? values[_dateTimeSegments.DateTimeSegment.Seconds] : undefined), (0, _defineProperty2.default)(_objectSpread2, _dateTimeSegments.DateTimeSegment.Milliseconds, showMilliseconds ? values[_dateTimeSegments.DateTimeSegment.Milliseconds] : undefined), _objectSpread2));
    });
  }, [showSeconds, showMilliseconds]); // Controlled case

  (0, _react.useEffect)(function () {
    // If value hasn't changed, no need to update
    if (value === stateValue.current) {
      return;
    }

    stateValue.current = value;

    if (!!value && (0, _utils2.isIsoFormat)(value)) {
      setSegmentValues((0, _utils2.dateStringToSegments)(value));
    } else {
      setSegmentValues({});
    }
  }, [value]);

  var handleClose = function handleClose() {
    setIsOpen(false);
  };

  var handleToggle = function handleToggle() {
    setIsOpen(function (prevIsOpen) {
      return !prevIsOpen;
    });
  };

  var handlePopoverEscKey = function handlePopoverEscKey() {
    calendarButtonRef && calendarButtonRef.current && calendarButtonRef.current.focus();
  };

  var handleChange = function handleChange(changes) {
    var newSegmentValues = _objectSpread(_objectSpread({}, segmentValues), changes); // Set default time if necessary


    if (!!defaultTime && (0, _utils2.hasAllDateValues)(newSegmentValues) && !(0, _utils2.hasAnyTimeValue)(newSegmentValues, showSeconds, showMilliseconds)) {
      newSegmentValues = _objectSpread(_objectSpread({}, newSegmentValues), defaultTime);
    }

    setSegmentValues(newSegmentValues);
    var newDate = (0, _utils2.dateTimeSegmentsToDate)(newSegmentValues, !!showSeconds, !!showMilliseconds);
    var dateTimeString = isNaN(newDate.getTime()) ? '' : newDate.toISOString();
    var hasPartialValue = !dateTimeString && (0, _utils2.hasAnySegmentValue)(newSegmentValues);
    stateValue.current = dateTimeString;
    !!onChange && onChange(dateTimeString, hasPartialValue);
  };

  var insetElementsWidth = _constants.INSET_ELEMENT_DEFAULTS.width * (hasSegmentValues ? 2 : 1);
  inputProps.padding = {
    right: disabled ? undefined : insetElementsWidth + _constants.INSET_ELEMENT_DEFAULTS.inset * 2
  };

  var dateTimeInputComponentProps = _objectSpread({
    ariaLabels: ariaLabels,
    calendarButtonAltText: calendarButtonAltText,
    calendarButtonRef: calendarButtonRef,
    clearButtonAltText: clearButtonAltText,
    datePickerProps: datePickerProps,
    containerRef: containerRef,
    handleChange: handleChange,
    id: id,
    labelIdProp: labelIdProp,
    locale: locale,
    segmentValues: segmentValues,
    showSeconds: showSeconds,
    showMilliseconds: showMilliseconds,
    inputProps: _objectSpread({
      disabled: disabled,
      error: error,
      warning: warning
    }, inputProps)
  }, dataTestProps);

  var dateTimeInputPopupContentProps = {
    ariaLabels: ariaLabels,
    datePickerProps: datePickerProps,
    disabled: disabled,
    handleChange: handleChange,
    locale: locale,
    segmentValues: segmentValues,
    setSegmentValues: setSegmentValues,
    showSeconds: showSeconds,
    showMilliseconds: showMilliseconds
  };
  var viewport = (0, _responsive.useBreakpoints)();
  return viewport.matches.s ? (0, _core.jsx)(_flyout.WithFlyout, {
    renderFlyout: function renderFlyout(_ref2) {
      var handleClose = _ref2.close;
      return (0, _core.jsx)(_flyout.FlyoutContent, {
        closeButtonAltText: collapsedCloseButtonAltText,
        onCloseButtonClick: handleClose,
        titleText: collapsedTitleText
      }, (0, _core.jsx)(_DateTimeInputPopupContent.default, dateTimeInputPopupContentProps));
    }
  }, function (_ref3) {
    var open = _ref3.open;
    return (0, _core.jsx)(_DateTimeInputComponent.default, (0, _extends2.default)({
      handleToggle: open,
      isOpen: false,
      isReadOnly: true
    }, dateTimeInputComponentProps));
  }) : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_DateTimeInputComponent.default, (0, _extends2.default)({
    handleToggle: handleToggle,
    isOpen: isOpen,
    isReadOnly: false
  }, dateTimeInputComponentProps)), (0, _core.jsx)(_popover.PopoverController, (0, _extends2.default)({}, popoverProps, {
    close: handleClose,
    isOpen: isOpen,
    onEscKey: handlePopoverEscKey,
    target: containerRef
  }), (0, _core.jsx)(_layout.View, {
    maxWidth: _constants.POPOVER_MAX_WIDTH,
    padding: _constants.POPOVER_PADDING
  }, (0, _core.jsx)(_DateTimeInputPopupContent.default, dateTimeInputPopupContentProps))));
};

var DateTimeInputWithDocs = (0, _stencilReactDesc.describe)(DateTimeInputWithoutDocs).description('An input field for entering UTC datetime strings.');
DateTimeInputWithDocs.propTypes = _propTypes.dateTimeInputPropTypes;
var DateTimeInput = (0, _utils.withTestAttributes)({
  component: 'StencilDateTimeInput'
})(DateTimeInputWithDocs);
DateTimeInput.defaultProps = _objectSpread({}, _constants.defaultDateTimeInputProps);
DateTimeInput.displayName = 'DateTimeInput';
var _default = DateTimeInput;
exports.default = _default;